import { ListResource, UnpagedListResource, createApiResource } from '../apiResourceFactory';
import { ServiceTitanAPI } from '../apiService';
import { ServiceTitanAppointmentQueryParams, ServiceTitanAppointment } from '../apiTypes.shim';

export interface ServiceTitanAppointmentResource
  extends ListResource<ServiceTitanAppointment, ServiceTitanAppointmentQueryParams>,
    UnpagedListResource<ServiceTitanAppointment, ServiceTitanAppointmentQueryParams> {}

export const createServiceTitanAppointmentResource = (companyId: string): ServiceTitanAppointmentResource => {
  const serviceTitanAppointmentUri = `${companyId}/appointments`;
  const { list, useList, unpagedList, useUnpagedList, listQueryKey, unpagedListQueryKey } = createApiResource(
    ServiceTitanAPI,
    serviceTitanAppointmentUri
  );

  return {
    list,
    useList,
    unpagedList,
    useUnpagedList,
    listQueryKey,
    unpagedListQueryKey
  };
};
